<template>
  <div>
    <div class="user_content">
      <img
        src="../../assets/img/trustlook-logo.png"
        alt=""
        class="logo"
        @click="jump('/dashboard')"
      />
      <div class="sign">
        <span ref="lang">
          <span @click="languageStatus = !languageStatus" class="choose icon-lang"></span>
          <el-collapse-transition>
            <ul class="language_selection" v-show="languageStatus">
              <li @click="switchLang('zh')" :class="{ active: lang === 'zh' }">中文</li>
              <li @click="switchLang('en')" :class="{ active: lang === 'en' }">English</li>
            </ul>
          </el-collapse-transition>
        </span>
      </div>
      <div class="content" id="register_container">
        <h2 class="title">{{ $t('user.ChangePassword') }}?</h2>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          class="signup_ruleForm"
        >
          <el-form-item prop="oldPass">
            <el-input
              type="password"
              v-model="ruleForm.oldPass"
              autocomplete="off"
              :placeholder="$t('user.OldPassword')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
              :placeholder="$t('user.NewPassword')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
              :placeholder="$t('user.ConfirmPassword')"
              @keyup.enter.native="getEnterCode"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn_sign" @click="submitForm('ruleForm')">
              <i class="el-icon-loading" v-if="loading"></i>{{ $t('message.CONFIRM') }}
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Message } from 'element-ui'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'ChangePass',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('errMsg.passwordErr1')))
      } else if (value.length < 6 || value.length > 20) {
        callback(new Error(this.$t('errMsg.passwordErr2')))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('errMsg.confirmPasswordErr1')))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error(this.$t('errMsg.confirmPasswordErr2')))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      languageStatus: false,
      user: {},
      email: '',
      ruleForm: {
        oldPass: '',
        pass: '',
        checkPass: ''
      },
      rules: {
        oldPass: [{ required: true, message: this.$t('errMsg.oldPasswordErr'), trigger: 'blur' }],
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }]
      }
    }
  },
  methods: {
    getEnterCode: function(e) {
      var keyCode = window.event ? e.keyCode : e.which
      if (keyCode == 13) {
        this.submitForm('ruleForm')
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          let data = {
            password: this.ruleForm.pass,
            oldPassword: this.ruleForm.oldPass
          }
          axios
            .post(`/api/user/${this.email}`, data)
            .then(response => {
              this.loading = false
              Message({ type: 'success', message: 'success', showClose: true })
              this.$router.push('/login').catch(err => {
                // to hide the below error message
                if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
                  throw Error(err)
                }
              })
            })
            .catch(err => {
              this.loading = false
              Message({ type: 'error', message: err.response.data, showClose: true })
            })
          this.$refs[formName].clearValidate()
        } else {
          Message({ type: 'error', message: this.$t('errMsg.err1'), showClose: true })
          return false
        }
      })
    },
    getUser() {
      axios
        .get('/api/user')
        .then(res => {
          this.user = res.data
          this.email = this.user.email
        })
        .catch(err => {
          this.$router.push('/login')
        })
    },
    jump(url) {
      this.$router.push(url)
    },
    switchLang(lang) {
      if (lang === this.$store.state.lang) return
      this.$store.commit('switchLang', lang)
      this.languageStatus = false
      Message({ type: 'success', message: this.$t('message.switchSuccessfully'), showClose: true })
      location.reload()
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  created() {
    this.getUser()
  },
  mounted() {
    let _this = this
    document.addEventListener('click', e => {
      if (!!_this.$refs.lang && !!_this.$refs.lang.contains(e.target)) return
      _this.languageStatus = false
    })
  }
}
</script>
<style lang="scss" src="./user.scss" scoped></style>
<style lang="scss" scoped>
.user_content {
  .logo {
    cursor: pointer;
  }
}
.content {
  width: 540px;
  height: 529px;
  box-sizing: border-box;
  padding: 0 70px;
  background: $bg-user-color;
  @include box-shadow2;
  @include border-radius(10px);
  .title {
    color: $white;
    font-size: 24px;
    height: 29px;
    margin: 60px 0 48px;
    font-family: NexaBold;
    font-weight: bold;
    text-align: center;
  }
  .signup_ruleForm {
    width: 100%;
    ::v-deep .el-form-item {
      margin-bottom: 40px;
    }
    ::v-deep .el-form-item__label {
      color: rgba(255, 255, 255, 0.4);
      margin-left: 16px;
      font-size: 16px;
    }
    .btn_sign {
      margin-top: 20px;
    }
  }
}
@media screen and (max-width: 450px) {
  .content {
    width: 100%;
    height: 394px;
    padding: 0 40px;
    background: none;
    box-shadow: none;
    margin-top: 25px;
    .title {
      margin-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/changePass.vue